import { LOGIN_URL, OTP_SENT, URL_FORGOT_PASSWORD, normalize_user_role } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { password_visibility_mixin } from '@/utils/mixins/password_visibility_mixin.js';
import axios from 'axios';
import $ from 'jquery';
import OnboardingIndex from '../OnboardingIndex.vue';

export default {
  name: 'UserLogin',
  mixins: [alert_mixin, password_visibility_mixin],
  components: {
    OnboardingIndex
  },
  data: () => ({
    username: '',
    password: '',
    eye_icon: 'bi-eye-slash',
    show_password: false,
    url_forgot_password: URL_FORGOT_PASSWORD,
    verification_running: false,
    title: "Welcome Back",
    submit_button_text: "Login",
    current_enquiry_form_id: '',
  }),
  computed: {
    show_enquiry_link() {
      // Get current domain
      let hostname = window.location.host.split(':')[0]; // without port
      let parts = hostname.split('.');
      parts.pop(); // Remove last part
      
      // If first part contains 'uat' (case-insensitive), remove it
      if (parts[0] && ['uat', 'stage', 'demo'].includes(parts[0].toLowerCase())) {
        parts.shift();
      }
      const current_domain = parts.join('.');
      // Hide for these domains
      const domains_to_hide = [
        "vettedafrica.complyon",
        "bolide.complyon"
      ];
      
      return !domains_to_hide.includes(current_domain);
    }
  },
  mounted() {
    this.document_ready();
    const redirect_reason = sessionStorage.getItem('auth_redirect_reason');

    if (redirect_reason) {
      this.show_error(redirect_reason);
      sessionStorage.removeItem('auth_redirect_reason');
    }

    // Detect domain and update title for Bolide
    let hostname = window.location.host.split(':')[0];
    if (hostname.includes('bolide.complyon')) {
      this.title = 'Shaping the Future of Utility Management';
    }
    
  },
  methods: {
    async handle_success_login(user_id, token) {
      await axios.post(OTP_SENT, { user_id }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`
        }
      });

      this.$router.push({
        path: '/one_time_pin',
      });
    },

    async login_function() {
      this.verification_running = true;

      if (!this.username) {
        this.verification_running = false;
        return this.show_info('A username is required to proceed.');
      }

      if (!this.password) {
        this.verification_running = false;
        return this.show_info('A password is required to proceed.');
      }

      try {
        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password,
        });

        const response_data = JSON.parse(response.data);

        if (response_data.status !== 'success') {
          this.show_error('Error during login');
          this.verification_running = false;
          return;
        }
        sessionStorage.setItem('user_id', response_data.user_id);
        sessionStorage.setItem('token', response_data.token);
        sessionStorage.setItem('user_role', normalize_user_role(response_data.role_type));
        sessionStorage.setItem('lead_id', response_data.lead_id);
        sessionStorage.setItem('lead_name', response_data.full_name);
        sessionStorage.setItem('is_aic_one_login', false);

        const is_first_time =
          response_data.first_time_login === true ||
          response_data.first_time_login === 'true';
        // Always rely on server response for consent; never reuse stale localStorage
        const terms_accepted =
          response_data.terms_accepted === true ||
          response_data.terms_accepted === 'true';

        sessionStorage.setItem('first_time_login', is_first_time ? 'true' : 'false');
        sessionStorage.setItem('terms_accepted', terms_accepted ? 'true' : 'false');

        if (response_data.first_time_login) {
          this.$router.push({
            path: '/first_time_login/',
            query: response_data
          });
        } else {
          await this.handle_success_login(response_data.user_id, response_data.token);
        }
      } catch (error) {
        this.handle_login_error(error);
      } finally {
        this.verification_running = false;
      }
    },

    handle_login_error(error) {
      const responseData = error?.response?.data;

      if (responseData && typeof responseData === 'object' && 'status' in responseData) {
        this.show_error('Invalid credentials');
        return;
      }

      if (typeof responseData === 'string' && responseData.trim().startsWith('{')) {
        const statusMatch = responseData.match(/"status"\s*:\s*(true|false|null|["\d]+)/);
        if (statusMatch) {
          this.show_error('Invalid credentials');
          return;
        }
      }
      this.show_error('Error during the connection to the server');
    },

    document_ready() {
      $('#show-password').on('change', function () {
        var password_field = $('.password');
        var password_field_type = password_field.attr('type');
        if (password_field_type === 'password') {
          password_field.attr('type', 'text');
        } else {
          password_field.attr('type', 'password');
        }
      });
    }
  },
};
